import {
  MessageBotEdgeTypesEnum,
  MessageBotNodeDataValues,
  MessageBotNodeInfos,
  MessageBotNodesEnum,
} from "@lib/types/MessageBot";

export const messageBotDefaultEdge = MessageBotEdgeTypesEnum.Dashed;

export const messageBotChildRoles = {
  [MessageBotNodesEnum.ROOT]: [MessageBotNodesEnum.ACTION],
  [MessageBotNodesEnum.ACTION]: [
    MessageBotNodesEnum.ACTION,
    MessageBotNodesEnum.POPUP,
  ],
  [MessageBotNodesEnum.POPUP]: [],
};

export const messageBotNodeInfos: MessageBotNodeInfos = {
  [MessageBotNodesEnum.ROOT]: {
    size: {
      width: 120,
      height: 100,
    },
    edges: {
      [MessageBotNodesEnum.ACTION]: {
        type: MessageBotEdgeTypesEnum.Dashed,
        label: "common.action",
      },
      [MessageBotNodesEnum.POPUP]: {
        type: MessageBotEdgeTypesEnum.Dashed,
        label: "common.popup",
      },
    },
  },
  [MessageBotNodesEnum.ACTION]: {
    size: {
      width: 100,
      height: 100,
    },
    edges: {
      [MessageBotNodesEnum.ACTION]: {
        type: MessageBotEdgeTypesEnum.Dashed,
        label: "common.action",
      },
    },
  },
  [MessageBotNodesEnum.POPUP]: {
    size: {
      width: 150,
      height: 120,
    },
    edges: {
      [MessageBotNodesEnum.ACTION]: {
        type: MessageBotEdgeTypesEnum.Dashed,
        label: "common.action",
      },
    },
  },
};

export const messageBotNodeDataValues: MessageBotNodeDataValues = {
  [MessageBotNodesEnum.ROOT]: {
    label: {
      messageId: "common.label",
      type: "input",
    },
  },
  [MessageBotNodesEnum.ACTION]: {
    label: {
      messageId: "common.label",
      type: "input",
    },
    message: {
      messageId: "common.message",
      type: "textarea",
    },
  },
  [MessageBotNodesEnum.POPUP]: {
    label: {
      messageId: "common.label",
      type: "input",
    },
    url: {
      messageId: "common.url",
      type: "input",
    },
  },
};
